export const vehicleType = [
    {
        id: 1,
        name:'Con người',
        license_plate:'',
        slots:[],
        tonnage:[],
    },
    {
        id: 2,
        name:'Xe máy',
        license_plate:'',
        slots:[],
        tonnage:[],
    },
    {
        id: 3,
        name:'Xe ô tô con',
        license_plate:'',
        slots:[],
        tonnage:[],
    }, 
    {
        id: 4,
        name:'Xe khách',
        license_plate:'',
        slots:[
            {   id: 1,
                value: 7,
                name: '7 chỗ'
            }, 
            {   id: 2,
                value: 9,
                name: '9 chỗ'
            }, 
            {   id: 3,
                value: 16,
                name: '16 chỗ'
            }, 
            {   id: 4,
                value: 24,
                name: '24 chỗ'
            }, 
            {   id: 5,
                value: 29,
                name: '29 chỗ'
            }, 
            {   id: 6,
                value: 35,
                name: '35 chỗ'
            }, 
            {   id: 7,
                value: 45,
                name: '45 chỗ'
            }, 
        ],
        tonnage:[],
    },
    {
        id: 5,
        name:'Xe container',
        license_plate:'',
        slots:[],
        tonnage:[],
    },
    {
        id: 6,
        name:'Xe tải',
        license_plate:'',
        slots:[],
        tonnage:[
            {   id: 1,
                value: 'Dưới 5T',
                name:'Dưới 5T', 
            },
            {   id: 2,
                value: 'Dưới 10T',
                name:'Dưới 10T', 
            },
            {   id: 3,
                value: 'Trên 10T',
                name:'Trên 10T', 
            },
        ],
    },
    {
        id: 7,
        name:'Xe bồn',
        license_plate:'',
        slots:[],
        tonnage:[],
    },
    {
        id: 8,
        name:'Thuyền',
        license_plate:'',
        slots:[],
        tonnage:[],
    },
]